import React, { useState, useEffect } from 'react';
import { supabaseAdmin as supabase } from '../../lib/supabase.js';

const tenantId = 'eadcd263-a399-4261-8cbd-8fb1ce6da0e3';

const DataStructureTest = () => {
  const [loading, setLoading] = useState(false);
  const [rawData, setRawData] = useState(null);
  const [error, setError] = useState('');

  const testDataStructure = async () => {
    try {
      setLoading(true);
      setError('');

      console.log('🔍 Testing data structure...');

      // Get one record to analyze its structure
      const { data, error: queryError } = await supabase
        .from('saas_teacher_timetables')
        .select('*')
        .eq('tenant_id', tenantId)
        .limit(1);

      if (queryError) {
        console.error('Query error:', queryError);
        setError(`Query Error: ${queryError.message}`);
        return;
      }

      console.log('📊 Raw data from database:', data);
      setRawData(data);

      if (data && data.length > 0) {
        const record = data[0];
        console.log('🔍 First record analysis:');
        console.log('  - ID:', record.id, 'Type:', typeof record.id);
        console.log('  - Teacher ID:', record.teacher_id, 'Type:', typeof record.teacher_id);
        console.log('  - Teacher Name:', record.teacher_name, 'Type:', typeof record.teacher_name);
        console.log('  - Day of Week:', record.day_of_week, 'Type:', typeof record.day_of_week);
        console.log('  - Time Slot:', record.time_slot, 'Type:', typeof record.time_slot);
        console.log('  - Subject:', record.subject, 'Type:', typeof record.subject);
        console.log('  - Class ID:', record.class_id, 'Type:', typeof record.class_id);
        console.log('  - Classroom:', record.classroom, 'Type:', typeof record.classroom);
        console.log('  - Created At:', record.created_at, 'Type:', typeof record.created_at);
        
        // Test ID operations
        console.log('🧪 Testing ID operations:');
        try {
          console.log('  - record.id.substring(0, 8):', record.id?.substring?.(0, 8));
        } catch (e) {
          console.error('  - substring error:', e.message);
        }
        
        try {
          console.log('  - String(record.id).substring(0, 8):', String(record.id).substring(0, 8));
        } catch (e) {
          console.error('  - String conversion error:', e.message);
        }
      } else {
        console.log('📭 No data found in database');
      }

    } catch (err) {
      console.error('Test error:', err);
      setError(`Test Error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    testDataStructure();
  }, []);

  return (
    <div className="data-structure-test bg-white rounded-lg shadow-md p-6 mb-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
        <span className="mr-2">🧪</span>
        Data Structure Test
      </h3>

      <div className="mb-4">
        <button
          onClick={testDataStructure}
          disabled={loading}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50"
        >
          {loading ? 'Testing...' : 'Run Structure Test'}
        </button>
      </div>

      {error && (
        <div className="mb-4 p-3 bg-red-100 text-red-800 border border-red-200 rounded-lg">
          <div className="flex items-center">
            <span className="mr-2">❌</span>
            {error}
          </div>
        </div>
      )}

      {rawData && (
        <div className="mb-4 p-4 bg-green-50 rounded-lg">
          <h4 className="font-medium text-green-700 mb-3">Raw Data Structure</h4>
          <div className="bg-white p-3 rounded border">
            <pre className="text-xs overflow-auto">
              {JSON.stringify(rawData, null, 2)}
            </pre>
          </div>
        </div>
      )}

      <div className="p-4 bg-blue-50 rounded-lg">
        <h4 className="font-medium text-blue-700 mb-2">What This Test Does:</h4>
        <ul className="text-sm text-blue-600 space-y-1">
          <li>• <strong>Fetches one record</strong> from the database</li>
          <li>• <strong>Analyzes data types</strong> of each field</li>
          <li>• <strong>Tests ID operations</strong> to find the substring error</li>
          <li>• <strong>Shows raw JSON</strong> structure of the data</li>
          <li>• <strong>Logs everything</strong> to browser console</li>
        </ul>
        <div className="mt-3 p-3 bg-blue-100 rounded border border-blue-200">
          <p className="text-sm text-blue-700">
            <strong>Check the browser console</strong> (F12 → Console) to see detailed analysis of your data structure.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DataStructureTest;
